<template>
  <div id="contactUs">
    <headNav>
      <div slot="headNavText">{{$t('message.info_lxwm')}}</div>
    </headNav>
    <div class="container">
      <ul>
        <li> {{$t('message.info_lxwm_server')}} <span>{{contact_tel}}</span></li>
        <li> {{$t('message.info_lxwm_time')}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import headNav from "../HeadNav/headNav";
  import {customer_tel} from '../../ports/port'
  export default {
    name: "contactUs",
    data(){
      return{
        contact_tel:''
      }
    },
    components:{
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      customer_tel()
        .then(res=>{
          if(res.data.code==200){
            this.contact_tel=res.data.data.contact_tel;
          }
        })
    }
  }
</script>

<style scoped lang="scss">
  @media (min-width:1430px) {
    #contactUs {
      padding: 70px 30px;
      .container {
        li{
          margin-bottom: 15px;
        }
      }
    }
  }
  @media (max-width:1430px) {
    #contactUs {
      padding: 1.4rem 0.3rem;
      .container {
        h1 {
          font-size: 0.53rem;
        }
        li{
          margin-bottom: 0.3rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/contact.vue